import { Component, ChangeDetectionStrategy, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import * as ReportModel from './report.model';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DataTypeComponent } from '../../../data-type-component';

@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-form-field-report',
  templateUrl: './report-form-field.component.html',
  styleUrls: ['./report-form-field.component.scss'],
  standalone: false,
})
export class ReportFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  report: any;

  constructor(
    private http: HttpClient,
    public domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.report = this.data;
  }

  ngOnDestroy() {}

  isChart(col: ReportModel.ReportColumnDO): boolean {
    return false;
  }

  getColFormat(table: ReportModel.ReportTableDO, row: ReportModel.ReportRowDO, col: ReportModel.ReportColumnDO) {
    if (col.f !== undefined && col.f.length > 0) {
      return this.getFormat(col.f);
    }
    if (row.f !== undefined && row.f.length > 0) {
      return this.getFormat(row.f);
    }
    if (table.f !== undefined && table.f.length > 0) {
      return this.getFormat(table.f);
    }
  }

  getRowFormat(table: ReportModel.ReportTableDO, row: ReportModel.ReportRowDO) {
    if (row.f !== undefined && row.f.length > 0) {
      return this.getFormat(row.f);
    }
    if (table.f !== undefined && table.f.length > 0) {
      return this.getFormat(table.f);
    }
  }

  getFormat(formats: any[]) {
    if (formats === undefined) {
      return '';
    }
    let cssClasses = '';
    formats.forEach((format) => (cssClasses = `${cssClasses} ${format}`));
    return cssClasses;
  }

  exportAsExcel(exportUrl: string, filename: string) {
    const { rbody } = this.route.snapshot.queryParams;
    this.http.post(exportUrl, rbody ? JSON.parse(rbody) : {}, { responseType: 'arraybuffer' }).subscribe((d) => {
      const blob = new Blob([d as any], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');

      link.href = url;
      link.style.display = 'none';
      // link.setAttribute('download', 'promotion_id_' + this.data.id + '_exported_on_' + moment().format('YYYY_MM_DD_HH_mm'));

      document.body.appendChild(link);

      link.setAttribute('download', `${filename}.xls`);
      link.setAttribute('target', '_external');

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  }

  exportAsPdf(exportUrl: string, filename: string) {
    const { rbody } = this.route.snapshot.queryParams;
    this.http.post(exportUrl, rbody ? JSON.parse(rbody) : {}, { responseType: 'arraybuffer' }).subscribe((d) => {
      const blob = new Blob([d as any], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.style.display = 'none';

      link.href = url;
      // link.setAttribute('download', 'promotion_id_' + this.data.id + '_exported_on_' + moment().format('YYYY_MM_DD_HH_mm'));

      document.body.appendChild(link);

      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  }

  transformStyle(style: string): SafeStyle {
    return this.domSanitizer.bypassSecurityTrustStyle(style);
  }

  getTableWidth(table: ReportModel.ReportTableDO): SafeStyle {
    const style: string = `width:${table.w === undefined ? '100' : table.w}%;`;
    return this.transformStyle(style);
  }

  getColWidth(
    table: ReportModel.ReportTableDO,
    row: ReportModel.ReportRowDO,
    col: ReportModel.ReportColumnDO,
    index: number
  ): SafeStyle {
    if (table.cw !== undefined) {
      if (index < table.cw.length) {
        return this.transformStyle(`width:${table.cw[index]}%;`);
      }
    }

    let width: number = 10;

    if (row !== undefined && row.c !== undefined) {
      width = 100 / row.c.length;
    }
    return this.transformStyle(`width:${width}%;`);

    // let style: string = 'width:' + width + '%;';
    // let style: string = 'max-width:' + width + '%;' +'min-width:' + width + '%;';
    // let style: string = '-webkit-box-flex: 0;';
    // style += '-webkit-flex: 0 0 ' + width + '%;';
    // style += '-ms-flex: 0 0 ' + width + '%;';
    // style += 'flex: 0 0 ' + width + '%;';
    // style += 'max-width: ' + width + '%;';
  }
}
